export class SideNavItem {
    className: string = '';
    title: string = '';
    route: string = '';
    icon: string = '';
    newicon: string = '';
    showChildren: boolean = false;
    
    children: SideNavItem[] = [];

    public toggleChildren(): void {
        this.showChildren = !this.showChildren;
    }
}